import axios from "axios";

export const getETHPrice = async () => {
    const res2 = await axios.get(`https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd`);
    return res2;
  };